import { buildEndAt, buildStartAt, deriveStatus } from './eventDtoShared';
import type { EventApiItem, EventItem } from '../../config';

export function adaptEventListItem(dto: EventApiItem): EventItem {
  return {
    id: dto.id,
    slug: dto.slug,
    title: dto.title,
    description: dto.description,
    image: dto.image,
    start_at: buildStartAt(dto.date_start_at, dto.time_start_at),
    end_at: buildEndAt(dto.date_start_at, dto.time_end_at),
    price: dto.price,
    available_seats: dto.available_seats,
    total_seats: dto.total_seats,
    status: deriveStatus(dto.available_seats),
  };
}
